import { useOnlineStatus } from '@/hooks/useOnlineStatus'

import styles from './OfflineBanner.module.css'

/** Says why nothing is loading, and warns that edits will not reach the server. */
export function OfflineBanner() {
  const isOnline = useOnlineStatus()
  if (isOnline) return null

  return (
    <div className={styles.banner} role="status">
      Keine Internetverbindung — Änderungen werden nicht gespeichert.
    </div>
  )
}
